import { Box, Typography } from "@mui/material";
import styled from "styled-components";
import BarCharts from "../../Charts/BarChart";
import { HitsArr } from "../../../types/types";

type Props = {
  filteredData: HitsArr[];
};

const ThirdGroup = ({ filteredData }: Props) => {
  const timeForSolving: any[] =
    filteredData?.map((data) => data._source.time_for_solving / 1000) ?? [];

  const timeForSolvingMax =
    timeForSolving.length > 0 ? Math.max(...timeForSolving) : 0;
  const timeForSolvingMin =
    timeForSolving.length > 0 ? Math.min(...timeForSolving) : 0;
  const timeForSolvingMedian =
    timeForSolving.length > 0 ? median_of_arr(timeForSolving) : 0;

  const solutionWeight: any[] =
    filteredData?.map((data) => data._source.solution_weight) ?? [];

  const solutionWeightMax =
    solutionWeight.length > 0 ? Math.max(...solutionWeight) : 0;
  const solutionWeightMin =
    solutionWeight.length > 0 ? Math.min(...solutionWeight) : 0;
  const solutionWeightMedian =
    solutionWeight.length > 0 ? median_of_arr(solutionWeight) : 0;

  function median_of_arr(arr: any) {
    const middle = (arr.length + 1) / 2;

    const sorted = [...arr].sort((a, b) => a - b);
    const isEven = sorted.length % 2 === 0;

    return isEven
      ? (sorted[middle - 1.5] + sorted[middle - 0.5]) / 2
      : sorted[middle - 1];
  }

  const solvingData = [
    {
      name: "Time",
      uv: timeForSolvingMax,
      pv: timeForSolvingMin,
      cv: timeForSolvingMedian,
      amt: 2400,
    },
  ];

  const solutionData = [
    {
      name: "Weight",
      uv: solutionWeightMax,
      pv: solutionWeightMin,
      cv: solutionWeightMedian,
      amt: 2400,
    },
  ];

  return (
    <ThirdCharts>
      <Box
        height="300px"
        marginBottom="12px"
        display="flex"
        justifyContent="space-evenly"
        alignItems="center"
        flexDirection="column-reverse"
      >
        <Typography variant="h6" textAlign="center">
          Solving Time (s)
        </Typography>
        <BarCharts data={solvingData} />
      </Box>
      <Box
        height="300px"
        marginBottom="12px"
        display="flex"
        justifyContent="space-evenly"
        alignItems="center"
        flexDirection="column-reverse"
      >
        <Typography variant="h6" textAlign="center">
          Solution Weight
        </Typography>
        <BarCharts data={solutionData} />
      </Box>
    </ThirdCharts>
  );
};

export default ThirdGroup;

const ThirdCharts = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;

  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    row-gap: 30px;
  }
`;
